import { Check, Clock, Hammer, Wrench, Layers, Sparkles, Boxes } from "lucide-react";

const STEPS = [
  { icon: Hammer, title: "Oude tegels verwijderen", desc: "Sloopwerk netjes en stofarm uitgevoerd." },
  { icon: Wrench, title: "Leidingen aanpassen", desc: "Water- en afvoerleidingen op maat gelegd." },
  { icon: Boxes, title: "Inbouwframe plaatsen", desc: "Geberit-frame stevig en strak gemonteerd." },
  { icon: Layers, title: "Toilet betegelen", desc: "Vakkundig tegelwerk in de stijl die jij kiest." },
  { icon: Sparkles, title: "Afkitten en afmonteren", desc: "Strakke afwerking, alles glimt en sluit aan." },
];

const PROCESS_IMG =
  "https://customer-assets.emergentagent.com/job_swift-toilet-pro/artifacts/ymo5eiei_IMG_20220913_000518_072.jpg";

export default function WatDoenWe() {
  return (
    <section
      id="wat-doen-we"
      className="bg-slate-50 py-20 lg:py-28"
      data-testid="wat-doen-we-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Centered intro */}
        <div className="max-w-3xl mx-auto text-center">
          <p className="text-sm font-bold uppercase tracking-[0.2em] text-orange-500">
            Wat doen we?
          </p>
          <h2 className="font-display font-bold mt-3 text-4xl sm:text-5xl tracking-tight text-slate-900">
            Van oude tegels tot{" "}
            <span className="text-blue-700">spik en span</span> nieuw toilet.
          </h2>
          <p className="mt-5 text-lg text-slate-600">
            Eén ploeg, één planning, één prijs. Wij regelen het hele
            renovatietraject van A tot Z, zodat jij geen omkijken hebt.
          </p>

          <div className="mt-8 inline-flex items-center gap-3 px-6 py-3 bg-orange-500 rounded-full text-white shadow-lg" data-testid="three-days-badge">
            <Clock className="w-5 h-5" />
            <span className="font-bold uppercase tracking-wider text-sm">
              Binnen gemiddeld 3 dagen
            </span>
          </div>
        </div>

        {/* Centered image */}
        <div className="mt-12 mx-auto max-w-3xl rounded-2xl overflow-hidden border-2 border-slate-900 shadow-xl">
          <img
            src={PROCESS_IMG}
            alt="Luxe badkamer afwerking door De Toiletman"
            className="w-full h-72 sm:h-96 object-cover"
            data-testid="process-image"
          />
        </div>

        {/* Steps grid centered */}
        <ol className="mt-16 grid sm:grid-cols-2 gap-5 max-w-4xl mx-auto">
          {STEPS.map((s, i) => {
            const Icon = s.icon;
            return (
              <li
                key={s.title}
                className="group relative flex gap-5 p-6 sm:p-7 rounded-2xl bg-white border border-slate-200 hover:border-blue-700 transition-colors"
                data-testid={`step-${i + 1}`}
              >
                <div className="flex-shrink-0">
                  <div className="w-14 h-14 rounded-xl bg-blue-700 text-white flex items-center justify-center group-hover:bg-orange-500 transition-colors">
                    <Icon className="w-6 h-6" />
                  </div>
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-3">
                    <span className="font-display font-bold text-2xl text-slate-300 leading-none">
                      0{i + 1}
                    </span>
                    <h3 className="font-display font-bold text-xl text-slate-900">
                      {s.title}
                    </h3>
                  </div>
                  <p className="mt-2 text-slate-600 leading-relaxed">{s.desc}</p>
                </div>
                <Check className="absolute top-6 right-6 w-5 h-5 text-orange-500" strokeWidth={3} />
              </li>
            );
          })}
        </ol>
      </div>
    </section>
  );
}
